import { render, staticRenderFns } from "./CurationApply.vue?vue&type=template&id=4730d5e9&scoped=true"
import script from "./CurationApply.vue?vue&type=script&lang=js"
export * from "./CurationApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4730d5e9",
  null
  
)

export default component.exports